export const normalizeCurrencyCode = (value: unknown): string => {
  if (typeof value !== 'string') return 'USD';
  const trimmed = value.trim();
  if (!trimmed) return 'USD';
  if (trimmed === '$') return 'USD';
  return trimmed.toUpperCase();
};

// Flutterwave charges in RWF; backend enforces RWF for all Flutterwave payments.
// Display conversion as an approximation (rounded to the nearest RWF).
export const convertUsdToRwf = (usdAmount: number, usdToRwfRate: number): number => {
  const safeUsd = Number.isFinite(usdAmount) ? usdAmount : 0;
  const safeRate = Number.isFinite(usdToRwfRate) && usdToRwfRate > 0 ? usdToRwfRate : 0;
  return Math.round(safeUsd * safeRate);
};

export const convertRwfToUsd = (rwfAmount: number, usdToRwfRate: number): number => {
  const safeRwf = Number.isFinite(rwfAmount) ? rwfAmount : 0;
  const safeRate = Number.isFinite(usdToRwfRate) && usdToRwfRate > 0 ? usdToRwfRate : 0;
  if (!safeRate) return 0;
  return safeRwf / safeRate;
};

export const formatRwf = (amountRwf: number): string => {
  const safeAmount = Number.isFinite(amountRwf) ? amountRwf : 0;
  try {
    return new Intl.NumberFormat('en-RW', {
      style: 'currency',
      currency: 'RWF',
      maximumFractionDigits: 0,
    }).format(safeAmount);
  } catch {
    return `RWF ${Math.round(safeAmount)}`;
  }
};

export const formatUsd = (amountUsd: number): string => {
  const safeAmount = Number.isFinite(amountUsd) ? amountUsd : 0;
  try {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(safeAmount);
  } catch {
    return `$ ${safeAmount.toFixed(2)}`;
  }
};
